// extracted by mini-css-extract-plugin
module.exports = {"item":"EarlyDocumentsCard_item__dJ7LD","stat":"EarlyDocumentsCard_stat__kLd8d","spin":"EarlyDocumentsCard_spin__QZQwC","pulse":"EarlyDocumentsCard_pulse__gFgEN"};